module.exports = __webpack_public_path__ + "img/Avatar-18.b8ad4932.gif";